import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useSelector } from 'react-redux'

import styles from './TaxInfoDialog.module.scss'

const EinInput = ({ setEin, ein, province, isCanadian }) => {
  const cultureCode = useSelector(s => s.hotelDetails.cultureCode)

  function getCanadianLabel() {
    if (province === 'AB') {
      return 'Corporate Access Number'
    }

    if (province === 'ON') {
      return 'Federal Corporation Business Number'
    }

    if (province === 'MB') {
      return 'Manitoba Corporation Number'
    }

    return 'Provincial Corporation Number'
  }

  function formatEIN(number) {
    var match = number.match(/(\d{2})(-)?(\d{1,7})?/)

    if (match) {
      //setEin(number)
      setEin(match[1] + '-' + (match[3] ? match[3] : ''))
    } else {
      setEin(number)
    }
  }

  function formatCAbusinessNumber(number) {
    var match = number.match(/(\d{9})(\s)?(\w{0,2})?(\d{0,4})?/)

    if (match) {
      setEin(
        match[1] +
          ((match[2] === undefined || match[2] === ' ') && match[3] ? ' ' : '') +
          (match[3]?.toUpperCase() || '') +
          (match[4] || '')
      )
    } else {
      setEin(number)
    }
  }

  if (isCanadian || cultureCode === 'en-CA') {
    return (
      <TextInput
        maxLength={16}
        minLength={16}
        placeholder="123456789 RT0001"
        value={ein}
        label={getCanadianLabel()}
        required
        onChange={e => formatCAbusinessNumber(e.target.value)}
        className={styles.input}
      />
    )
  } else {
    return (
      <TextInput
        label="Employer identification number"
        maxLength={10}
        minLength={10}
        placeholder="xx-xxxxxxx"
        value={ein}
        required
        onChange={e => formatEIN(e.target.value)}
        className={styles.input}
      />
    )
  }
}

export default EinInput
